<template>
  <NuxtLink :to="{ name: 'user-profile' }">
    <Button v-if="isLoggedIn" class="bg-primary">Profile</Button>
  </NuxtLink>
  <Button v-if="!isLoggedIn" @click="() => handleLogin()" class="bg-primary">Log in</Button>
  <Button v-if="isLoggedIn" @click="() => handleLogout()" class="bg-primary">Log out</Button>
  <!-- <Button @click="() => test()" class="bg-primary">test</Button> -->
</template>
<script setup lang="ts">
const authClientStore = useAuthClientStore();
const { isLoggedIn } = storeToRefs(useAuthNStore());

function handleLogin() {
  authClientStore.statefulLogin();
}

function handleLogout() {
  authClientStore.statefulLogout();
}
</script>
